const CV_CONFIG = {
  width: 210,
  height: 297,
  resolution: 3,
  fileName: 'ric-vasquez-cv.pdf',
  version: '20260617',
  page: {
    scale: 0.345,
    offsetX: 0,
    offsetY: 3,
  },
  links: {
    linkedIn: 'https://x.com/ricvasquez',
    email: 'mailto:ric@ricvasquez.com',
    pdf: '/pdf/ric-vasquez-cv.pdf',
  }
}

const CV_LINKS_CONFIG = [
  {
    // Repurposed: the "LET'S COLLABORATE →" button on Ric's resume.
    // Opens CV_CONFIG.links.linkedIn -> https://x.com/ricvasquez
    partTypeKey: 'LinkedIn',
    partTypeValue: 'linkedin',
    x: 0,
    y: -0.27,
    width: 0.36,
    height: 0.05,
    texture: null,
  },
  {
    partTypeKey: 'EMail',
    partTypeValue: 'email',
    x: 0.251,
    y: -0.447,
    width: 0.2,
    height: 0.017,
    texture: null,
  },
  {
    partTypeKey: 'OpenPDF',
    partTypeValue: 'open-pdf',
    x: 0,
    y: 0.52,
    width: 0.482 * 0.35,
    height: 0.175 * 0.35,
    texture: 'open-pdf-button',
  }
]

export { CV_CONFIG, CV_LINKS_CONFIG };
